import { axiosInstance } from "../../axios/axiosInstance";
import {
  ADMIN_API_URL,
  API_BASE_URL,
  getDefaultHeaders,
} from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getDsgSettings = () =>
  axiosInstance.get(`${ADMIN_API_URL}/setting/get-dsg`, {
    headers: authHeaders(),
  });

export const updateDsgSettingsRequest = (settingsData) =>
  axiosInstance.post(`${ADMIN_API_URL}/dsg-settings-update`, settingsData, {
    headers: authHeaders(),
  });

export const getDsgLookup = (endpoint) =>
  axiosInstance.get(`${API_BASE_URL}${endpoint}`, {
    headers: authHeaders(),
  });
